// extracted by mini-css-extract-plugin
export var inputContainer = "_or-0";